import React, { useEffect, useRef } from 'react'

import SiteSearch from '@modules/site-search'
import MainLogo from '@images/logo/mygateway_logo_no_text.png'
// import TextlessLogo from '@images/logo/white.png'

const styles = {
  phone: {
    textAlign: 'left',
  },
  logo: {
    margin: '0 1rem',
    padding: '0.35rem 0',
    height: '80%',
    width: 'auto',
  },
}

export default function Header(props) {
  const { toggled, togglePanel, hideSearchbar } = props
  const headerRef = useRef(null)

  useEffect(() => {
    const el = headerRef.current
    if (!el || typeof ResizeObserver == 'undefined') return

    const setHeaderHeight = () =>
      document.documentElement.style.setProperty(
        '--header-height',
        `${el.offsetHeight}px`
      )

    setHeaderHeight()
    const observer = new ResizeObserver(setHeaderHeight)
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  const img = toggled ? null : (
    <div className='logo-block' style={{ display: 'flex', alignItems: 'center', overflow: 'hidden', height: '100%' }}>
      <img style={styles.logo} src={MainLogo} alt='My Gateway Logo' />
      <span style={{color: '#fff', fontWeight: 'bold', fontSize: '0.9rem'}} className='logo-text'>MYGATEWAY</span>
    </div>
  )

  return (
    <header className='main-header' ref={headerRef}>
      <div className='logo-header' data-background-color='blue2'>
        {img}

        <button
          onClick={togglePanel}
          className='navbar-toggler sidenav-toggler ml-auto'
          aria-label='Toggle navigation'
        >
          <span className='navbar-toggler-icon'>
            <i className='fas fa-bars'></i>
          </span>
        </button>

        <div className='nav-toggle'>
          <button
            onClick={togglePanel}
            className={
              'btn btn-toggle toggle-sidebar ' + (toggled ? 'toggled' : '')
            }
          >
            <i className={'fas fa-' + (toggled ? 'ellipsis-v' : 'bars')}></i>
          </button>
        </div>
      </div>

      <nav
        className='navbar navbar-header navbar-expand-lg'
        data-background-color='blue2'
      >
        <div className='container-fluid'>
          {!hideSearchbar && <SiteSearch />}

          <div className='navbar-nav topbar-nav ml-md-auto align-items-center social-icons'>
            <li className='nav-item dropdown hidden-caret submenu d-none d-lg-block'>
              <a
                className='nav-link dropdown-toggle'
                href='#'
                id='help-numbers'
                role='button'
                data-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'
              >
                <i className='fas fa-phone'></i>
              </a>
              <ul
                className='dropdown-menu notif-box animated fadeIn'
                aria-labelledby='help-numbers'
              >
                <li className='dropdown-title'>Call Center Phone Numbers</li>
                <li className='dropdown-title' style={styles.phone}>
                  <a href='tel:2426044357'>(242) 604-4357 (HELP)</a>
                </li>
                <li className='dropdown-title' style={styles.phone}>
                  <a href='tel:2428254321'>(242) 825-4321</a>
                </li>
              </ul>
            </li>

            {/* <li className='nav-item'>
              <a
                href='https://www.facebook.com/Digital-Transformation-Unit-106568484621561'
                className='nav-link'
              >
                <i className='fab fa-facebook'></i>
              </a>
            </li> */}
          </div>
        </div>
      </nav>
    </header>
  )
}
